import { FC, ReactNode } from 'react';
import { SxProps, Theme, Typography, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  text?: string | null;
  iconBefore?: ReactNode;
  iconAfter?: ReactNode;
  color?:
    | 'disabled'
    | 'primary'
    | 'inherit'
    | 'error'
    | 'info'
    | 'secondary'
    | 'action'
    | 'success'
    | 'warning';
  sx?: SxProps<Theme>;
}

const Status: FC<Props> = ({ text, iconBefore, iconAfter, color, sx }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const textColor = {
    disabled: theme.palette.text.disabled,
    primary: theme.palette.primary.main,
    inherit: 'inherit',
    error: theme.palette.error.main,
    info: theme.palette.info.main,
    secondary: theme.palette.secondary.main,
    action: theme.palette.action,
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
  }[color || 'inherit'];

  return (
    <>
      {iconBefore}
      <Typography
        variant={'body2'}
        sx={{
          mx: theme.spacing(0.5),
          color: `${textColor}`,
          ...sx,
        }}
      >
        <Trans t={t}>{text}</Trans>
      </Typography>
      {iconAfter}
    </>
  );
};

export default Status;
